
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33871',
  depVersions: {
  "documents-public-ui": "static-1.33871",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33876",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1884",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5350",
  "hs-test-utils": "static-1.7765",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11181",
  "I18n": "static-7.1558",
  "jasmine-immutable": "static-1.2778",
  "jasmine-runner": "static-1.6233",
  "lodash": "static-1.3",
  "quartz": "static-1.6673",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16400",
  "reporting-data": "static-1.66344",
  "reporting-testing-lib": "static-1.8277",
  "reporting-visualizations": "static-1.58420",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4525",
  "webpack-env": "static-1.54",
  "atom": "static-1.4830",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2245",
  "classnames": "static-2.10",
  "cssUtils": "static-1.720",
  "customer-data-filters-ui": "static-1.38736",
  "customer-data-objects": "static-1.7403",
  "customer-data-property-utils": "static-1.7831",
  "data-fetching-client": "static-1.9436",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4290",
  "flux-actions": "static-1.302",
  "FormsCommonComponents": "static-1.85201",
  "FormUrlGenerator": "static-2.4490",
  "foundations-components": "static-1.7437",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11489",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6922",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3619",
  "property-translator": "static-1.5173",
  "quartz-config": "static-1.451",
  "quartz-core": "static-1.5892",
  "quick-fetch": "static-1.3695",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5138",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7919",
  "reference-resolvers-lite": "static-1.7849",
  "report-customization-components": "static-1.12375",
  "reporting-enablement": "static-1.21937",
  "reporting-reports": "static-1.66022",
  "reporting-snowflake": "static-1.54962",
  "reporting-ui-components": "static-2.63616",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4391",
  "sales-content-partitioning": "static-1.8694",
  "SalesContentIndexUI": "static-3.8842",
  "sanitize": "static-1.4234",
  "sanitize-text": "static-1.7899",
  "self-service-api": "static-1.9999",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1513",
  "signup-constants": "static-1.18307",
  "signup-ui-lego-core": "static-1.20317",
  "signup-ui-url-generator": "static-2.7821",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4531",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10754",
  "ui-addon-i18n": "static-1.10890",
  "ui-addon-react-router-dom": "static-1.9307",
  "ui-addon-upgrades": "static-9.17590",
  "ui-asset-management-lib": "static-1.10655",
  "ui-images": "static-2.1081",
  "UIComponents": "static-3.8128",
  "usage-tracker": "static-1.7093",
  "usage-tracker-container": "static-1.7083",
  "usage-tracker-core": "static-1.6943",
  "usage-tracker-public": "static-1.6904",
  "viral-links-lib": "static-1.6786",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3191",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2950",
  "quartz-webpack": "static-1.2897",
  "ai-components-ui-library": "static-1.8234",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4591",
  "foundations-theming": "static-1.4168",
  "quartz-auth": "static-1.348",
  "usage-tracker-session-replay": "static-1.4779",
  "foundations-theming-base": "static-1.3153",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2876",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4090",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7686",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3466",
  "reporting-client-types": "static-1.2369",
  "hs-story-utils": "static-1.9187",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9380",
  "hubspotter-http": "static-1.4442",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7008",
  "crm-message-bus": "static-1.42230",
  "customer-data-filters-ui-msw-helpers": "static-1.21170",
  "customer-data-objects-ui-components": "static-1.12762",
  "customer-data-reference-ui-components": "static-1.12900",
  "customer-data-ui-utilities": "static-1.9584",
  "framework-builder-read-service-client": "static-1.3811",
  "framework-data-schema-quick-fetch": "static-1.6533",
  "framework-data-schema-resolvers": "static-1.6628",
  "inbound-db-properties-service-client": "static-1.3640",
  "multi-account-reference-resolvers": "static-1.728",
  "onboarding-tours": "static-1.16203",
  "reporting-datasets-permissions-lib": "static-1.12928",
  "ui-addon-teams": "static-1.21185",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67505",
  "customer-data-properties": "static-1.50653",
  "forms-ai-lib": "static-1.3951",
  "forms-utils-lib": "static-1.12095",
  "foundations-components-test-utils": "static-1.4920",
  "react-dnd-compat": "static-1.4383",
  "react-tinymce": "static-1.54513",
  "tinymce-config": "static-2.53639",
  "ui-gdpr-components": "static-1.10106",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3706",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1081",
  "ui-fonts": "static-1.443",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.784",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-head": "static-1.338",
  "quartz-i18n": "static-1.348",
  "quartz-routing": "static-1.103",
  "quartz-test": "static-1.348",
  "batch-promise": "static-1.1309",
  "external-options-client-types": "static-1.3947",
  "react-colorpicker": "static-2.9971",
  "copilot-toolkit": "static-1.10419",
  "data-quality-ui-library": "static-1.12227",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40532",
  "reporting-insights-lib": "static-1.1044",
  "reporting-plugins": "static-1.9930",
  "ui-addon-draggable-compat": "static-2.4013",
  "ui-addon-opt": "static-4.8146",
  "ui-shepherd-react": "static-3.9904",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24613",
  "hubspot-apollo-client": "static-1.4638",
  "sales-templates-service-types-lib": "static-1.3957",
  "ui-business-units-lib": "static-1.8782",
  "merchandise-lib": "static-1.257",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5424",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3868",
  "upgrade-management-service-types": "static-1.4267",
  "timezone-utils": "static-2.5003",
  "bender-build-tools": "static-1.2894",
  "chatspot-core": "static-1.20149",
  "chirp-fetch": "static-1.1642",
  "bend-plugin-foundations-theming": "static-1.2651",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9378",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3587",
  "crm-pipelines-api-client-types": "static-1.3928",
  "multi-currency-client-types": "static-1.3482",
  "getting-started-shared-tasks": "static-1.17767",
  "growth-data-modal": "static-1.5113",
  "growth-onboarding-confetti": "static-1.2829",
  "growth-onboarding-next-action-utils": "static-1.1254",
  "navigation-components": "static-1.17137",
  "onboarding-tours-client": "static-1.4417",
  "onboarding-tours-utils": "static-1.269",
  "ui-shepherd-tracker": "static-1.7285",
  "ui-universal-auth": "static-1.8636",
  "user-context": "static-1.4854",
  "cms-field-types": "static-1.4566",
  "content-icons-ui": "static-1.2140",
  "integrations-lib": "static-1.15288",
  "calling-global-api": "static-1.63527",
  "calling-internal-common": "static-1.31051",
  "calling-lifecycle-internal": "static-1.64909",
  "calling-lifecycle-messages": "static-1.57203",
  "commerce-products-lib": "static-1.8730",
  "crm-links": "static-1.6013",
  "file-manager-components": "static-1.22767",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.430",
  "inbounddb-objects-service-types": "static-1.4014",
  "meetings-icalendar-utils-lib": "static-1.393",
  "object-builder-ui-client": "static-1.47837",
  "pipeline-validation-client-types": "static-1.3751",
  "property-value-citations": "static-1.1267",
  "pulse": "static-1.259",
  "smart-property-lib": "static-1.5735",
  "tiered-pricing": "static-1.769",
  "ui-addon-iframeable": "static-1.8800",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19404",
  "tinymce-themes": "static-1.55609",
  "data-token-picker": "static-1.15978",
  "hub-http-contrib": "static-1.2804",
  "interframe": "static-3.4551",
  "tinymce-data": "static-1.39724",
  "tinymce-plugins": "static-1.56753",
  "ui-addon-sales-email": "static-1.4972",
  "magpie-lib": "static-1.5353",
  "magpie-types": "static-1.4813",
  "simple-logging-lib": "static-1.2810",
  "content-assistance-lib": "static-1.7386",
  "dashboard-lib": "static-1.80450",
  "ExportDialog": "static-6.10147",
  "hubspot-prosemirror": "static-1.17491",
  "hubspot-prosemirror-plugins": "static-1.17483",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8449",
  "campaign-roi-lib": "static-1.8163",
  "feedback-loader": "static-1.28775",
  "onboarding-scopes": "static-1.6224",
  "apollo-link-hub-http": "static-2.4408",
  "hubspot-apollo-cache": "static-1.97",
  "growth-monetization-service-types": "static-1.4283",
  "nav-client-types": "static-1.2115",
  "purchase-motions-api": "static-1.5427",
  "trials-service-types": "static-1.3684",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.485",
  "getting-started-shared-tasks-store": "static-1.16885",
  "integrations-error-boundary-lib": "static-1.12703",
  "integrations-tracking-lib": "static-1.5343",
  "native-integrations-shared-strings": "static-1.7548",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10132",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31057",
  "shared-worker-versioning": "static-1.10797",
  "calling-usage-tracker": "static-1.6298",
  "voice-sms-access-library": "static-1.119",
  "customer-data-tracking": "static-1.6641",
  "products-iframe-lib": "static-1.7209",
  "products-ui-components-shared-msw-handlers": "static-1.9762",
  "location-customization-utils-lib": "static-1.8431",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3914",
  "video-components-external": "static-1.10457",
  "video-data-lib": "static-1.34115",
  "directed-graph": "static-1.696",
  "event-emitter": "static-1.707",
  "breeze-intelligence-kit": "static-1.5258",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9463",
  "fsm": "static-1.3491",
  "policy-lib": "static-1.6544",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9526",
  "navigation-messaging": "static-1.6464",
  "FileManagerLib": "static-1.38407",
  "NamespacedHubStyle": "static-2.8860",
  "FileManagerCore": "static-1.38266",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11958",
  "layout-dnd-utils": "static-1.10933",
  "react-codemirror": "static-1.10387",
  "ui-addon-emoji-picker": "static-1.9649",
  "ui-brand-identity-lib": "static-1.13670",
  "ui-addon-video-player": "static-1.8453",
  "ui-coaching-tips": "static-1.27837",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8327",
  "payment-link-components": "static-1.22826",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2965",
  "universal-page-editor-lib": "static-1.2758",
  "calling-orchestration-schema": "static-1.34896",
  "sales-views-client-types": "static-1.4051",
  "crm-record-cards-service-types": "static-1.3415",
  "content-media-composition-data-lib": "static-1.11305",
  "content-media-compositions": "static-2.15312",
  "media-bridge-lib": "static-1.18500",
  "trellis-story-utils": "static-1.4281",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5551",
  "FileManagerImages": "static-1.35918",
  "video-components": "static-1.12460",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4292",
  "video-embed": "static-1.34949",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67580",
  "layout-data-lib": "static-1.9258",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6344",
  "commerce-tours-lib": "static-1.5660",
  "growth-onboarding-reliability": "static-1.4848",
  "sales-checkout-service-client": "static-1.3436",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21240",
  "sales-email-signature-service-client": "static-1.3602",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21243",
  "outpost": "static-1.3967",
  "advanced-menus-core": "static-1.14756",
  "advanced-menus-lib": "static-1.11739",
  "ui-memberships-settings-lib": "static-1.33321",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14755",
  "simple-menus-lib": "static-1.16272"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33871",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33876",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1884",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5350",
  "hs-test-utils": "/hs-test-utils/static-1.7765",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11181",
  "I18n": "/I18n/static-7.1558",
  "jasmine-immutable": "/jasmine-immutable/static-1.2778",
  "jasmine-runner": "/jasmine-runner/static-1.6233",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6673",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16400",
  "reporting-data": "/reporting-data/static-1.66344",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8277",
  "reporting-visualizations": "/reporting-visualizations/static-1.58420",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4525",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4830",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2245",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.720",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38736",
  "customer-data-objects": "/customer-data-objects/static-1.7403",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7831",
  "data-fetching-client": "/data-fetching-client/static-1.9436",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4290",
  "flux-actions": "/flux-actions/static-1.302",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85201",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4490",
  "foundations-components": "/foundations-components/static-1.7437",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11489",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6922",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3619",
  "property-translator": "/property-translator/static-1.5173",
  "quartz-config": "/quartz-config/static-1.451",
  "quartz-core": "/quartz-core/static-1.5892",
  "quick-fetch": "/quick-fetch/static-1.3695",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5138",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7919",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7849",
  "report-customization-components": "/report-customization-components/static-1.12375",
  "reporting-enablement": "/reporting-enablement/static-1.21937",
  "reporting-reports": "/reporting-reports/static-1.66022",
  "reporting-snowflake": "/reporting-snowflake/static-1.54962",
  "reporting-ui-components": "/reporting-ui-components/static-2.63616",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4391",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8694",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8842",
  "sanitize": "/sanitize/static-1.4234",
  "sanitize-text": "/sanitize-text/static-1.7899",
  "self-service-api": "/self-service-api/static-1.9999",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1513",
  "signup-constants": "/signup-constants/static-1.18307",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20317",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7821",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4531",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10754",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10890",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9307",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17590",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10655",
  "ui-images": "/ui-images/static-2.1081",
  "UIComponents": "/UIComponents/static-3.8128",
  "usage-tracker": "/usage-tracker/static-1.7093",
  "usage-tracker-container": "/usage-tracker-container/static-1.7083",
  "usage-tracker-core": "/usage-tracker-core/static-1.6943",
  "usage-tracker-public": "/usage-tracker-public/static-1.6904",
  "viral-links-lib": "/viral-links-lib/static-1.6786",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3191",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2950",
  "quartz-webpack": "/quartz-webpack/static-1.2897",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8234",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4591",
  "foundations-theming": "/foundations-theming/static-1.4168",
  "quartz-auth": "/quartz-auth/static-1.348",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4779",
  "foundations-theming-base": "/foundations-theming-base/static-1.3153",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2876",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4090",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7686",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3466",
  "reporting-client-types": "/reporting-client-types/static-1.2369",
  "hs-story-utils": "/hs-story-utils/static-1.9187",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9380",
  "hubspotter-http": "/hubspotter-http/static-1.4442",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7008",
  "crm-message-bus": "/crm-message-bus/static-1.42230",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21170",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12762",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12900",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9584",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3811",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6533",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6628",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3640",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.728",
  "onboarding-tours": "/onboarding-tours/static-1.16203",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12928",
  "ui-addon-teams": "/ui-addon-teams/static-1.21185",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67505",
  "customer-data-properties": "/customer-data-properties/static-1.50653",
  "forms-ai-lib": "/forms-ai-lib/static-1.3951",
  "forms-utils-lib": "/forms-utils-lib/static-1.12095",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4920",
  "react-dnd-compat": "/react-dnd-compat/static-1.4383",
  "react-tinymce": "/react-tinymce/static-1.54513",
  "tinymce-config": "/tinymce-config/static-2.53639",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10106",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3706",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1081",
  "ui-fonts": "/ui-fonts/static-1.443",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-head": "/quartz-head/static-1.338",
  "quartz-i18n": "/quartz-i18n/static-1.348",
  "quartz-routing": "/quartz-routing/static-1.103",
  "quartz-test": "/quartz-test/static-1.348",
  "batch-promise": "/batch-promise/static-1.1309",
  "external-options-client-types": "/external-options-client-types/static-1.3947",
  "react-colorpicker": "/react-colorpicker/static-2.9971",
  "copilot-toolkit": "/copilot-toolkit/static-1.10419",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12227",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40532",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1044",
  "reporting-plugins": "/reporting-plugins/static-1.9930",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4013",
  "ui-addon-opt": "/ui-addon-opt/static-4.8146",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9904",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24613",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4638",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3957",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8782",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5424",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3868",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4267",
  "timezone-utils": "/timezone-utils/static-2.5003",
  "bender-build-tools": "/bender-build-tools/static-1.2894",
  "chatspot-core": "/chatspot-core/static-1.20149",
  "chirp-fetch": "/chirp-fetch/static-1.1642",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2651",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9378",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3587",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3928",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3482",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17767",
  "growth-data-modal": "/growth-data-modal/static-1.5113",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2829",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1254",
  "navigation-components": "/navigation-components/static-1.17137",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4417",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.269",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7285",
  "ui-universal-auth": "/ui-universal-auth/static-1.8636",
  "user-context": "/user-context/static-1.4854",
  "cms-field-types": "/cms-field-types/static-1.4566",
  "content-icons-ui": "/content-icons-ui/static-1.2140",
  "integrations-lib": "/integrations-lib/static-1.15288",
  "calling-global-api": "/calling-global-api/static-1.63527",
  "calling-internal-common": "/calling-internal-common/static-1.31051",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64909",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57203",
  "commerce-products-lib": "/commerce-products-lib/static-1.8730",
  "crm-links": "/crm-links/static-1.6013",
  "file-manager-components": "/file-manager-components/static-1.22767",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.430",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4014",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.393",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47837",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3751",
  "property-value-citations": "/property-value-citations/static-1.1267",
  "pulse": "/pulse/static-1.259",
  "smart-property-lib": "/smart-property-lib/static-1.5735",
  "tiered-pricing": "/tiered-pricing/static-1.769",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8800",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19404",
  "tinymce-themes": "/tinymce-themes/static-1.55609",
  "data-token-picker": "/data-token-picker/static-1.15978",
  "hub-http-contrib": "/hub-http-contrib/static-1.2804",
  "interframe": "/interframe/static-3.4551",
  "tinymce-data": "/tinymce-data/static-1.39724",
  "tinymce-plugins": "/tinymce-plugins/static-1.56753",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4972",
  "magpie-lib": "/magpie-lib/static-1.5353",
  "magpie-types": "/magpie-types/static-1.4813",
  "simple-logging-lib": "/simple-logging-lib/static-1.2810",
  "content-assistance-lib": "/content-assistance-lib/static-1.7386",
  "dashboard-lib": "/dashboard-lib/static-1.80450",
  "ExportDialog": "/ExportDialog/static-6.10147",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17491",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17483",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8449",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8163",
  "feedback-loader": "/feedback-loader/static-1.28775",
  "onboarding-scopes": "/onboarding-scopes/static-1.6224",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4408",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.97",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4283",
  "nav-client-types": "/nav-client-types/static-1.2115",
  "purchase-motions-api": "/purchase-motions-api/static-1.5427",
  "trials-service-types": "/trials-service-types/static-1.3684",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.485",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16885",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12703",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5343",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7548",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10132",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31057",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10797",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6298",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.119",
  "customer-data-tracking": "/customer-data-tracking/static-1.6641",
  "products-iframe-lib": "/products-iframe-lib/static-1.7209",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9762",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8431",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3914",
  "video-components-external": "/video-components-external/static-1.10457",
  "video-data-lib": "/video-data-lib/static-1.34115",
  "directed-graph": "/directed-graph/static-1.696",
  "event-emitter": "/event-emitter/static-1.707",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5258",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9463",
  "fsm": "/fsm/static-1.3491",
  "policy-lib": "/policy-lib/static-1.6544",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9526",
  "navigation-messaging": "/navigation-messaging/static-1.6464",
  "FileManagerLib": "/FileManagerLib/static-1.38407",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8860",
  "FileManagerCore": "/FileManagerCore/static-1.38266",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11958",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10933",
  "react-codemirror": "/react-codemirror/static-1.10387",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9649",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13670",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8453",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27837",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8327",
  "payment-link-components": "/payment-link-components/static-1.22826",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2965",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2758",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34896",
  "sales-views-client-types": "/sales-views-client-types/static-1.4051",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3415",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11305",
  "content-media-compositions": "/content-media-compositions/static-2.15312",
  "media-bridge-lib": "/media-bridge-lib/static-1.18500",
  "trellis-story-utils": "/trellis-story-utils/static-1.4281",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5551",
  "FileManagerImages": "/FileManagerImages/static-1.35918",
  "video-components": "/video-components/static-1.12460",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4292",
  "video-embed": "/video-embed/static-1.34949",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67580",
  "layout-data-lib": "/layout-data-lib/static-1.9258",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6344",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5660",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4848",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3436",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21240",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3602",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21243",
  "outpost": "/outpost/static-1.3967",
  "advanced-menus-core": "/advanced-menus-core/static-1.14756",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11739",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33321",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14755",
  "simple-menus-lib": "/simple-menus-lib/static-1.16272"
}
};
